/**
 * @generated SignedSource<<2050b7124e60f28e016afa642e6146c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AvatarCard_projects$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly cover: {
        readonly " $fragmentSpreads": FragmentRefs<"ProjectCoverWrapper_portfolioProjectCover">;
      };
      readonly id: string;
      readonly slug: string;
    };
  }>;
  readonly " $fragmentType": "AvatarCard_projects";
};
export type AvatarCard_projects$key = {
  readonly " $data"?: AvatarCard_projects$data;
  readonly " $fragmentSpreads": FragmentRefs<"AvatarCard_projects">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AvatarCard_projects",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfilePortfolioProjectEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioProject",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "cover",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProjectCoverWrapper_portfolioProjectCover"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfilePortfolioProjectConnection",
  "abstractKey": null
};

(node as any).hash = "087a613dfd364cdeef9161b2873b1c82";

export default node;
